import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsVisitationCommunityHeatmapTappedParams = {
  trail_id: number;
};

/**
 * User tap community heatmap button in Visitation module.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsVisitationCommunityHeatmapTapped = (
  { trail_id }: logTrailDetailsVisitationCommunityHeatmapTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent('trail details visitation community heatmap tapped', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsVisitationCommunityHeatmapTapped;
